import { useEffect, useState } from 'react';
import './Agreement.css';
import axios from 'axios';
import { API_BASE_URL } from '../utils';


export default function ClubAgreement() {
    const [termsCondition, setTermsCondition] = useState()
    const [isloading, setisLoading] = useState(false)

    useEffect(() => {
        const fetchData = async () => {
            try {
                setisLoading(true)
                const res = await axios.get(`${API_BASE_URL}/master/Api/getData/getWebsiteSettings`)
                const { status, data } = res.data;
                console.log('Website Settings:', data);

                status === true ? setTermsCondition(data[0].clubtermsConditions) : setTermsCondition(null)
                setisLoading(false)
            } catch (error) {
                setisLoading(false)
                console.log(error)
            }
        }
        fetchData()
    }, [])

    return (
        <div class="clubagreement pt-5" dangerouslySetInnerHTML={{ __html: `<div style="color:#fff;"> ${isloading ? 'Loading...' : termsCondition}</div>` }} />
    );
}